import { FilterInputProps } from '../types';
import { AddFilterButton } from './atoms';
import { ReportFilterSidebarContent } from './ReportFilterSidebarContent';
import { IconName } from '@ardoq/icons';
import { SidebarMenu } from '@ardoq/sidebar-menu';
import { ListPopoverOptionProps } from '@ardoq/table-filter-bar';

import type { ReportFilterSidebarLabels } from '../labels';

const DEFAULT_HEADER_TITLE = 'Filters';

export type ReportFilterSidebarProps = {
  addFilterButtonOptions: ListPopoverOptionProps[];
  filtersToRender: FilterInputProps[];
  onCloseClick?: VoidFunction;
  labels?: ReportFilterSidebarLabels;
};

export const ReportFilterSidebar = ({
  addFilterButtonOptions,
  filtersToRender,
  onCloseClick,
  labels,
}: ReportFilterSidebarProps) => {
  return (
    <SidebarMenu
      headerTitle={labels?.headerTitle ?? DEFAULT_HEADER_TITLE}
      headerLeftIconName={IconName.FILTER_LIST}
      isPageBodyMenu
      isRightContent
      headerTitleTestId={'REPORT_FILTER_SIDEBAR'}
      headerRightContent={
        <AddFilterButton
          options={addFilterButtonOptions}
          labels={labels?.addFilterButton}
        />
      }
      onCloseClick={onCloseClick}
    >
      <ReportFilterSidebarContent
        filtersToRender={filtersToRender}
        labels={labels?.content}
      />
    </SidebarMenu>
  );
};
